import _isArray from 'lodash/isArray';
import _isEqual from 'lodash/isEqual';
import _cloneDeep from 'lodash/cloneDeep';
import {boolSearchParams, saleDateOptions} from '../lib/config';

const keysToIgnore = [
  'rentedDateEnd',
  'soldDateEnd'
];

export const isSavedSearchesFetched = (state) => {
  return state.userSavedSearches.status === 'success';
};

export const isSearchSaved = (state) => {
  const isAuthenticated = state.user.authenticated;
  const userSavedSearches = state.userSavedSearches;
  const currSearchQuery = state.searchProperties.status === 'success' ? _cloneDeep(state.searchProperties.results.payload.query) : null;
  const currSearchSort = state.searchProperties.status === 'success' ? _cloneDeep(state.searchProperties.results.payload.sort) : null;

  if (currSearchQuery) {
    currSearchQuery.queries.forEach((q) => {
      q.types = q.hasOwnProperty('types') && _isArray(q.types) ? q.types : [];
      if (q.category.toLowerCase().includes('listing') && q.hasOwnProperty('additionalFeaturesQuery')) {
        q.additionalFeaturesQuery.featureFreeText = q.additionalFeaturesQuery.hasOwnProperty('featureFreeText') &&
        _isArray(q.additionalFeaturesQuery.featureFreeText)? q.additionalFeaturesQuery.featureFreeText : [];
      }
    });
  }

  const savedSearchQueries = userSavedSearches.status === 'success' && _isArray(userSavedSearches.savedSearches) ?
    userSavedSearches.savedSearches.map((savedSearch => {
      return {
        queries: savedSearch.query.queries.map(q => ({
          ...q,
          stateCode: _isArray(q.stateCode) &&q.stateCode.length === 1 ? q.stateCode[0] : q.stateCode,
        })),
        sort: savedSearch.sort || [],
      };
    })) : [];


  const searchSaved = isAuthenticated && currSearchQuery && savedSearchQueries.some((ssq, queryNum) => {
    let equalSort = false;
    // sort is equal if current sort is not set and ssq.sort is empty
    // or if current sort is set and ssq.sort is the same
    if (
      (!currSearchSort && ssq.sort.length == 0) || 
      (currSearchSort && ssq.sort.length && _isEqual(currSearchSort, ssq.sort))
    ) equalSort = true;

    const retVal = ssq.queries.length === currSearchQuery.queries.length && equalSort && ssq.queries.every((q, index) => (
      Object.keys(q).every((key) => {
        if (key === 'types') {
          return _isEqual(currSearchQuery.queries[index].types, q.types);
        }

        if (key === 'additionalFeaturesQuery' && currSearchQuery.queries[index].hasOwnProperty('additionalFeaturesQuery')) {
          return isAdditionalFeaturesEqual(currSearchQuery, q, index);
        }

        if(keysToIgnore.includes(key)) {
          return currSearchQuery.queries[index].hasOwnProperty(key);
        } else if(boolSearchParams.includes(key) && !currSearchQuery.queries[index].hasOwnProperty(key)) {
          currSearchQuery.queries[index][key] = false;
        }

        if(key === 'filteredMonths') {
          const soldDateStartValue = saleDateOptions.find(dateOption => dateOption.label === decodeURI(currSearchQuery.queries[index]['soldDateStart'])).value;
          return soldDateStartValue === q[key];
        }

        if(key === 'saleTypes') {
          return _isEqual(currSearchQuery.queries[index].saleTypes, q.saleTypes);
        }

        return currSearchQuery.queries[index][key] == q[key];
      })
    ) && Object.keys(q).length === Object.keys(currSearchQuery.queries[index]).length);

    return retVal;
  });

  return searchSaved;
};


const isAdditionalFeaturesEqual = (currentQuery, savedQuery, queryIndex) => {
  const key = 'additionalFeaturesQuery';
  if (savedQuery.category.toLowerCase().includes('listing')) {
    return Object.keys(savedQuery.additionalFeaturesQuery).every((afq) => {
      return afq === 'featureFreeText' ?
        _isEqual(currentQuery.queries[queryIndex][key].featureFreeText, savedQuery[key].featureFreeText) :
        currentQuery.queries[queryIndex][key][afq] == savedQuery[key][afq];
    }) && Object.keys(savedQuery.additionalFeaturesQuery).length === Object.keys(currentQuery.queries[queryIndex].additionalFeaturesQuery).length;
  } else if (!currentQuery.queries[queryIndex].hasOwnProperty(key)) {
    currentQuery.queries[queryIndex].additionalFeaturesQuery = {};
  }
  return true;
};
